<template>
  <div class="lv-meeting-item-attach-upload-list">
    <LvUploadFileList
      :value="value"
      upload
      multiple
      draggable
      showDeleteBtn
      acceptFileType="pdf"
      versionMode="version"
      dragTitleKey="exportName"
      :title="title"
      :uploadModule="uploadModule"
      class="lv-popup-choose-file__upload-file-list"
      @go-to="$emit('go-to', $event)"
      @input="$_onInput($event)"
      @submit-drag="$_onSubmitDrag($event)"
    >
      <template v-slot:header="{ index }">
        <LvDivider v-if="index > 0" />
        <LvCheckbox
          v-if="index >= 0"
          h4
          exclusive
          isTextLeft
          text="是否匯出附件名稱"
          justifyContent="flex-start"
          :value="true"
          :select="value[index].isExportName"
          class="mb-4"
          @change="$_onCheckIsExportName($event, index)"
        />
        <LvFlexBox class="mb-4">
          <LvText h5>{{ $t('附件名稱位置') }}</LvText>
          <RadioButton
            v-model="value[index].exportNameLocation"
            row
            isNarrow
            :radioButtonItem="exportNameLocationRadioItems"
            :disable="!value[index].isExportName"
          >
            <template v-slot="{ radio }">
              <LvText h6>{{ $t(radio.textLabel) }}</LvText>
            </template>
          </RadioButton>
        </LvFlexBox>
        <StateInputButton
          v-if="index >= 0"
          v-model="value[index].exportName"
          required
          title="匯出附件名稱"
          rules="required"
          placeholder="輸入"
          class="mb-8"
        />
      </template>
    </LvUploadFileList>
    <WsTextChip001
      red
      thin
      leadingIcon="icon-warning"
      textLabel="注意，若附件含有加密保護或限制編輯權限，將導致匯出作業無法完成"
    />
  </div>
</template>

<script>
import Spare_meeting from '@/spare/meeting';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: '附件',
    },
    uploadModule: {
      type: String,
    },
  },
  data() {
    return {
      exportNameLocationRadioItems: Spare_meeting.exportNameLocationRadioItems,
    };
  },
  methods: {
    $_onSubmitDrag(sortList) {
      this.$emit('input', sortList);
    },
    $_onCheckIsExportName($event, index) {
      this.value[index].isExportName = $event;
    },
    $_onInput($event) {
      if (!$event) return;
      // 新上傳的附件補上匯出名稱相關預設值
      const attaches =
        $event.length > 0
          ? $event.map(attach => {
              if (attach.exportName !== undefined && attach.isExportName !== undefined) {
                return attach;
              }
              return {
                ...attach,
                exportName: attach.name,
                isExportName: true,
                exportNameLocation: 'top-right',
              };
            })
          : [];
      // 避免無限循環：只有當值真的改變時才更新
      const currentAttaches = this.value || [];
      if (attaches.length !== currentAttaches.length) {
        this.$emit('input', attaches);
        return;
      }
      const hasChanged = attaches.some((attach, index) => {
        const current = currentAttaches[index];
        return (
          !current ||
          current.id !== attach.id ||
          current.exportName !== attach.exportName ||
          current.exportNameLocation !== attach.exportNameLocation ||
          current.isExportName !== attach.isExportName ||
          current.versionId !== attach.versionId ||
          current.fileVersion !== attach.fileVersion
        );
      });
      if (hasChanged) {
        this.$emit('input', attaches);
      }
    },
  },
};
</script>
